(function (host, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (host && host.document) api.boot(host);
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  var STORAGE_KEY = 'pg:wish'; // Owned by PGWishlist; retained legacy storage contract.
  var PAGE_SIZE = 12;

  function productRoot(value) {
    return typeof value === 'string' && /^\/(?:[a-z]{2}(?:-[A-Za-z]{2,4})?\/)?$/.test(value) ? value : '/';
  }
  function shareUrl(path, fragment, search) {
    if (!/^\/(?:[a-z]{2}(?:-[A-Za-z]{2,4})?\/)?pages\/[\p{L}\p{M}\p{N}_™®-]+$/u.test(path) || !fragment) return null;
    var url = new URL(path, 'https://pixelgipfel.ch');
    var preview = new URLSearchParams(search || '').get('preview_theme_id');
    if (preview && /^[0-9]{1,20}$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
    url.hash = fragment;
    return url.toString();
  }
  function imageUrl(value) {
    if (typeof value !== 'string' || value.length > 2048 || /[\u0000-\u0020\\]/.test(value)) return null;
    try {
      var url = new URL(value, 'https://pixelgipfel.ch');
      return url.protocol === 'https:' && !url.username && !url.password &&
        ['pixelgipfel.ch', 'www.pixelgipfel.ch', 'cdn.shopify.com'].indexOf(url.hostname) >= 0 ? url.href : null;
    } catch (e) { return null; }
  }

  function mount(root, win, store) {
    if (!root || root.dataset.pgWishlistPageWired === '1' || !store) return;
    root.dataset.pgWishlistPageWired = '1';
    var doc = root.ownerDocument || win.document;
    var nodes = {};
    ['i18n','empty','content','grid','clear','clear-confirm','clear-cancel','clear-panel','count','status','loading','more','share','share-panel','share-link','copy','import','import-list','import-count','merge','replace','dismiss'].forEach(function (name) {
      nodes[name] = root.querySelector('[data-pg-wishlist-' + name + ']');
    });
    var copy = {};
    try { copy = JSON.parse(nodes.i18n.textContent); } catch (e) {}
    var prefix = productRoot(root.getAttribute('data-product-root'));
    var locale = root.getAttribute('data-locale') || 'de-CH';
    var currency = root.getAttribute('data-currency') || 'CHF';
    var visible = PAGE_SIZE;
    var generation = 0;
    var disposed = false;
    var cache = new Map();
    var controllers = new Set();
    var incoming = null;
    var lastList = '';
    function text(key) { return copy[key] || ''; }
    function status(key) { nodes.status.textContent = text(key); }
    function element(tag, className, value) {
      var node = doc.createElement(tag);
      if (className) node.className = className;
      if (value !== undefined) node.textContent = value;
      return node;
    }
    function link(handle, label, className) {
      var node = element('a', className, label);
      node.href = prefix + 'products/' + encodeURIComponent(handle);
      return node;
    }
    function money(price) {
      if (!Number.isSafeInteger(price) || price < 0) return '';
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(price / 100); }
      catch (e) { return currency + ' ' + (price / 100).toFixed(2); }
    }
    function fetchProduct(handle) {
      if (cache.has(handle)) return cache.get(handle);
      var controller = new win.AbortController();
      controllers.add(controller);
      var timeout = win.setTimeout(function () { controller.abort(); }, 10000);
      var promise = win.fetch(prefix + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', signal: controller.signal })
        .then(function (response) {
          if (response.status === 404) return { kind: 'missing' };
          if (!response.ok) throw new Error('product response');
          return response.json().then(function (product) {
            if (!product || typeof product.title !== 'string' || (product.handle && product.handle !== handle)) throw new Error('product shape');
            return { kind: 'product', product: product };
          });
        })
        .catch(function () { return { kind: 'error' }; })
        .finally(function () { win.clearTimeout(timeout); controllers.delete(controller); });
      cache.set(handle, promise);
      return promise;
    }
    function card(handle, result) {
      var product = result.product;
      var title = product ? product.title : handle.replace(/-/g, ' ');
      if (product && win.PGProductTitle) title = win.PGProductTitle(handle, title);
      var article = element('article', 'pg-wish__card');
      article.setAttribute('data-pg-wishlist-card', handle);
      var remove = element('button', 'pg-wish__card-remove', '×');
      remove.type = 'button';
      remove.setAttribute('aria-label', text('remove') + ': ' + title);
      remove.addEventListener('click', function () { store.remove(handle); nodes.count.focus(); });
      var photo = link(handle, '', 'pg-wish__photo');
      photo.setAttribute('aria-label', title);
      var src = product && imageUrl(product.featured_image || (product.images && product.images[0]));
      if (src) {
        var img = element('img');
        img.src = src; img.alt = ''; img.width = 480; img.height = 360; img.loading = 'lazy';
        photo.appendChild(img);
      } else photo.textContent = text('image');
      var heading = element('h2', 'pg-wish__name');
      heading.appendChild(link(handle, title));
      article.appendChild(remove); article.appendChild(photo); article.appendChild(heading);
      if (product) {
        var meta = element('div', 'pg-wish__meta');
        meta.appendChild(element('span', 'pg-wish__price', money(product.price)));
        meta.appendChild(element('span', 'pg-wish__stock', product.available === true ? text('inStock') : text('outOfStock')));
        article.appendChild(meta);
      } else {
        article.appendChild(element('p', 'pg-wish__card-note', text(result.kind === 'missing' ? 'missing_detail' : 'load_error')));
        if (result.kind === 'error') {
          var retry = element('button', 'pg-wish__retry', text('retry'));
          retry.type = 'button';
          retry.addEventListener('click', function () { cache.delete(handle); render(); nodes.count.focus(); });
          article.appendChild(retry);
        }
      }
      article.appendChild(link(handle, text('view'), 'pg-wish__view'));
      return article;
    }
    function updateShare() {
      var list = store.read();
      nodes.share.disabled = list.length === 0;
      if (nodes['share-panel'].hidden) return;
      var url = shareUrl(root.getAttribute('data-share-path'), store.encodeShare(list), win.location.search);
      nodes['share-link'].value = url || '';
      nodes.copy.disabled = !url;
      if (!url) status('share_unavailable');
    }
    async function render() {
      var version = ++generation;
      var handles = store.read();
      var current = JSON.stringify(handles);
      if (current !== lastList) { lastList = current; nodes['clear-panel'].hidden = true; }
      nodes.count.textContent = String(handles.length);
      nodes.count.setAttribute('aria-label', String(handles.length) + ' ' + text('count_label'));
      nodes.empty.hidden = handles.length > 0;
      nodes.content.hidden = handles.length === 0;
      nodes.clear.disabled = handles.length === 0;
      nodes.more.hidden = handles.length <= visible;
      nodes.more.disabled = true;
      nodes.loading.hidden = handles.length === 0;
      nodes.grid.setAttribute('aria-busy', handles.length ? 'true' : 'false');
      nodes.grid.replaceChildren();
      updateShare();
      if (!handles.length) return;
      var shown = handles.slice(0, visible);
      var results = await Promise.all(shown.map(fetchProduct));
      if (disposed || version !== generation) return;
      nodes.grid.replaceChildren.apply(nodes.grid, results.map(function (result, index) { return card(shown[index], result); }));
      nodes.loading.hidden = true;
      nodes.more.disabled = false;
      nodes.grid.setAttribute('aria-busy', 'false');
    }
    function clearFragment() {
      try { win.history.replaceState(win.history.state, '', win.location.pathname + win.location.search); } catch (e) {}
      incoming = null;
      nodes.import.hidden = true;
      nodes.count.focus();
    }
    function previewImport() {
      var parsed = store.decodeShare(win.location.hash);
      incoming = null; nodes.import.hidden = true; nodes['import-list'].replaceChildren();
      if (!parsed.present) return;
      if (parsed.error) { status('invalid_link'); return; }
      incoming = parsed.list;
      nodes['import-count'].textContent = String(incoming.length);
      incoming.forEach(function (handle) {
        var li = element('li');
        li.appendChild(link(handle, handle.replace(/-/g, ' ')));
        nodes['import-list'].appendChild(li);
      });
      nodes.import.hidden = false;
    }
    function importList(mode) {
      if (!incoming) return;
      var result = store.importList(incoming, mode);
      if (!result.ok) { status(result.error === 'limit' ? 'limit' : 'invalid_link'); return; }
      clearFragment();
      status(result.persisted ? 'imported' : 'storage_error');
      nodes.count.focus();
    }
    function changed(event) {
      if (event && event.detail && event.detail.error) status(event.detail.error === 'limit' ? 'limit' : 'storage_error');
      else if (event && event.detail) nodes.status.textContent = '';
      render();
    }
    nodes.more.addEventListener('click', function () { visible += PAGE_SIZE; render(); nodes.count.focus(); });
    nodes.clear.addEventListener('click', function () { nodes['clear-panel'].hidden = false; nodes['clear-confirm'].focus(); });
    nodes['clear-cancel'].addEventListener('click', function () { nodes['clear-panel'].hidden = true; nodes.clear.focus(); });
    nodes['clear-confirm'].addEventListener('click', function () { var result = store.write([]); status(result.persisted ? 'clear_done' : 'storage_error'); nodes.count.focus(); });
    nodes.share.addEventListener('click', function () {
      nodes['share-panel'].hidden = !nodes['share-panel'].hidden;
      nodes.share.setAttribute('aria-expanded', String(!nodes['share-panel'].hidden));
      updateShare();
      if (!nodes['share-panel'].hidden) { nodes['share-link'].focus(); nodes['share-link'].select(); }
    });
    nodes.copy.addEventListener('click', async function () {
      if (!nodes['share-link'].value) return;
      try {
        if (!win.navigator.clipboard || !win.navigator.clipboard.writeText) throw new Error('clipboard unavailable');
        await win.navigator.clipboard.writeText(nodes['share-link'].value);
        status('copied');
      } catch (e) { nodes['share-link'].focus(); nodes['share-link'].select(); status('copy_manual'); }
    });
    nodes.merge.addEventListener('click', function () { importList('merge'); });
    nodes.replace.addEventListener('click', function () { importList('replace'); });
    nodes.dismiss.addEventListener('click', clearFragment);
    doc.addEventListener('pg:wish-updated', changed);
    win.addEventListener('hashchange', previewImport);
    function dispose(event) {
      if (event && event.target && event.target !== root && !(event.target.contains && event.target.contains(root))) return;
      disposed = true; generation += 1;
      controllers.forEach(function (controller) { controller.abort(); });
      doc.removeEventListener('pg:wish-updated', changed);
      doc.removeEventListener('shopify:section:unload', dispose);
      win.removeEventListener('hashchange', previewImport);
    }
    doc.addEventListener('shopify:section:unload', dispose);
    previewImport();
    if (!store.isPersistent()) status('storage_error');
    render();
    return { render: render, dispose: dispose };
  }

  function boot(win) {
    function initAll(scope) {
      if (!win.PGWishlist) return;
      if (scope.matches && scope.matches('[data-pg-wishlist]')) mount(scope, win, win.PGWishlist);
      scope.querySelectorAll('[data-pg-wishlist]').forEach(function (root) { mount(root, win, win.PGWishlist); });
    }
    win.document.addEventListener('pg:wish-ready', function () { initAll(win.document); });
    win.document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    if (win.document.readyState === 'loading') win.document.addEventListener('DOMContentLoaded', function () { initAll(win.document); });
    else initAll(win.document);
  }
  return { STORAGE_KEY: STORAGE_KEY, PAGE_SIZE: PAGE_SIZE, productRoot: productRoot, shareUrl: shareUrl, imageUrl: imageUrl, mount: mount, boot: boot };
});
